import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import ShowLoading from '../helperComponent/ShowLoading';
import AddNotesForm from './AddNotesForm';
import NoteItem from './NoteItem';
import notesImg from '../../assets/open-book.png';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();
const NotesPage = () => {
  const [buttonText, setButtonText] = useState('Add Notes');
  const [showAddNotes, setAddNotes] = useState(false);
  const [notes, setNotes] = useState([]);
  const [page, setPage] = useState(1);
  const [next, setNext] = useState(1);
  const [showLoading, setShowLoading] = useState(true);

  let history = useHistory();

  const uname = JSON.parse(localStorage.getItem('uname'));
  const URL = 'https://stucharge.bakersbrisk.com/api/notesapi';
  let fetchURL = `https://stucharge.bakersbrisk.com/api/notesapi?username=${uname}&page=${page}`;

  const AuthStr = process.env.REACT_APP_AUTH_STR;

  // fetch notes
  useEffect(() => {
    axios
      .get(fetchURL, { headers: { Authorization: AuthStr } })
      .then((response) => {
        // If request is good...
        if (response.status === 200) {
          if (
            response.data.length > 0 &&
            !response.data[response.data.length - 1].has_next
          )
            setNext(0);
          setNotes(response.data);
          setShowLoading(false);
        } else if (response.status !== 200)
          toast.error('Something went wrong, please refresh');
      })
      .catch((error) => {
        if (error) console.log(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchURL]);

  // adding notes to database
  const addNotes = ({
    title,
    price,
    offerPrice,
    description,
    image,
    formData,
    download,
    sub,
  }) => {
    var bodyFormData = new FormData();
    bodyFormData.append('pdf', formData);
    bodyFormData.append('cover_image', image);
    bodyFormData.append('title', title);
    bodyFormData.append('price', price);
    bodyFormData.append('offer_price', offerPrice);
    bodyFormData.append('description', description);
    bodyFormData.append('username', uname);
    bodyFormData.append('subject', sub);
    if (download) {
      bodyFormData.append('downloadable', 'True');
    } else {
      bodyFormData.append('downloadable', 'False');
    }
    // send notes data to server
    axios
      .post(URL, bodyFormData, {
        headers: { Authorization: AuthStr },
      })
      .then(function (response) {
        if (response.status === 201) toast.success('Notes added successfully!');
        history.push('/home');
        history.push('/notes');
      })
      .catch((error) => {
        if (error) toast.error('Something went wrong, please try again');
      });
  };

  // on click handler
  const onClickHandler = () => {
    setAddNotes(!showAddNotes);
    setButtonText(buttonText === 'Add Notes' ? 'Close' : 'Add Notes');
  };

  return (
    <main>
      <div className='main_container'>
        <div className='main_title'>
          <img src={notesImg} alt='profile' width='50' />
          <div className='main_greeting'>
            <h1>Lecture Notes</h1>
            <p>Uploaded notes are visible here</p>
            {showLoading && <ShowLoading />}
          </div>
        </div>
        <div className='add-notes'>
          <button
            onClick={onClickHandler}
            style={{
              background: showAddNotes ? '#ef4f4f' : '#00b5c3',
            }}
          >
            {buttonText}
          </button>
        </div>

        {showAddNotes && <AddNotesForm addNotes={addNotes} />}

        {notes.length > 0 ? (
          <>
            <div className='table-container'>
              <table className='table'>
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Offer Price</th>
                    <th>Downloadable</th>
                    <th>View</th>
                    <th>Edit </th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  <NoteItem notes={notes} />
                </tbody>
              </table>
            </div>
            <div className='change-page'>
              {page > 1 ? (
                <button
                  type='button'
                  onClick={() => setPage(page > 1 ? page - 1 : 1)}
                >
                  Prev
                </button>
              ) : null}
              {next === 1 ? (
                <button type='button' onClick={() => setPage(page + 1)}>
                  Next
                </button>
              ) : null}
            </div>
          </>
        ) : (
          <div className='alert-heading'>
            <h1>No Notes uploaded</h1>
          </div>
        )}
      </div>
    </main>
  );
};

export default NotesPage;
